export default __webpack_public_path__ + "static/media/ponentes_formato.c7aa23d9.xlsx";